<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
  [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
  [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <app-filters filtros
    [name]="'filtros.per' | translate"
    [array]="Periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="cambioPeriodo($event)"
    [click]="false"
  ></app-filters>

  <div contenido class="contenidoV">
    <div class="tabla">
      <div class="headers w3-titulo-contenidomenuSC">
        <div class="w3-half">
          <span class="w3-margin-left-contenido">{{ 'liquidez.cobertura.tituloTabla' | translate }}</span>
          <span class="w3-margin-left-contenido">&bull;</span>
          <span class="w3-margin-left-filter w3-subtitulo">{{escrituraPer(subTitles)}}</span>
        </div>
        <div class="w3-rest w3-right">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
          [matMenuTriggerFor]="menuGrafPrincipalTable">
            more_vert
          </mat-icon>
          <mat-menu #menuGrafPrincipalTable="matMenu">
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportExcel()">
                  <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
                  <span>{{'menu.Exportar' | translate}}</span>
            </button>
          </mat-menu>
        </div>
      </div>
      <div class="zonaTabla w3-scroll">
          <table class="w3-table allBordes">
            <thead class="">
              <tr class="w3-table-title">
                <th colspan="4" class="alinCenter w3-elemento-titulo-table borderIzq">
                  {{ 'liquidez.cobertura.tituloTabla1' | translate }}
                </th>
              </tr>
              <tr class="w3-table-title borderSup borderInf">
                <th class="alinCenter w3-elemento-titulo-table borderIzq stikyColum">
                  {{ 'liquidez.cobertura.ecabezadoTabla1' | translate }}
                </th>
                <th class="alinCenter w3-elemento-titulo-table borderIzq stikyColum">
                  {{ 'liquidez.cobertura.ecabezadoTabla2' | translate }}
                </th>
                <th class="alinCenter w3-elemento-titulo-table borderIzq stikyColum">
                  {{ 'liquidez.cobertura.ecabezadoTabla3' | translate }}
                </th>
                <th class="alinCenter w3-elemento-titulo-table borderIzq stikyColum">
                  {{ 'liquidez.cobertura.ecabezadoTabla4' | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              @for (tab of dataOrdenado; track tab; let t = $index) {
                <tr><th colspan="4" class="alinCenter borderIzq"></th></tr>
                <tr>
                  <th colspan="4" class="alinCenter w3-elemento-titulo-table borderIzq">
                    {{ 'liquidez.cobertura.tituloTabla'+(t+2) | translate }}
                  </th>
                </tr>
                @if (t+2 === 5) {
                  <tr>
                    <th class="alinCenter w3-elemento-titulo-table borderIzq borderSup">
                      {{ 'liquidez.cobertura.subTituloTabla'+(t+2)+'1' | translate }}
                    </th>
                    <th class="alinCenter w3-elemento-titulo-table borderIzq borderSup">
                      {{ 'liquidez.cobertura.subTituloTabla'+(t+2)+'2' | translate }}
                    </th>
                    <th class="alinCenter w3-elemento-titulo-table borderIzq borderSup">
                      {{ 'liquidez.cobertura.subTituloTabla'+(t+2)+'3' | translate }}
                    </th>
                    <th class="alinCenter w3-elemento-titulo-table borderIzq borderSup">
                      {{ 'liquidez.cobertura.subTituloTabla'+(t+2)+'4' | translate }}
                    </th>
                  </tr>
                }
                @for (dat of tab; track dat; let d = $index) {
                  @if (dat.codigo==='encabezado' && t !== dataOrdenado.length-1) {
                    <tr class="w3-table-trtd">
                      <td colspan="4" class="w3-elemento-tableIndicador borderIzq alinCenter">{{dat.concepto}}</td>
                    </tr>
                  }
                  @if (dat.codigo!=='encabezado' && t !== dataOrdenado.length-1) {
                    <tr class="w3-table-trtd borderSup" [ngClass]="{'total':dat.codigo==='suma'||dat.codigo==='subtot'}">
                      <td class="w3-elemento-tableIndicador borderInf borderIzq">{{dat.concepto}}</td>
                      <td class="w3-elemento-tableIndicador borderInf borderIzq alinCenter anchoValores">
                        <span>{{dat.factor}}</span>
                        @if (dat.codigo!=='suma' && dat.codigo!=='subtot') {
                          %
                        }
                      </td>
                      <td class="w3-elemento-tableIndicador borderInf borderIzq alinRight anchoValores">
                        <span style="margin-right: 5%;">{{formNum(dat.saldo, false)}}</span>
                      </td>
                      <td class="w3-elemento-tableIndicador borderInf borderIzq alinRight anchoValores" style="margin-right: 5%;">
                        <span style="margin-right: 5%;">{{formNum(dat.admisible, false)}}</span>
                      </td>
                    </tr>
                  }
                  @if (dat.codigo!=='encabezado' && t === dataOrdenado.length-1) {
                    <tr class="w3-table-trtd" [ngClass]="{'total':dat.codigo==='suma'||dat.codigo==='subtot'}">
                      <td class="w3-elemento-tableIndicador borderIzq" [ngClass]="{'borderInf borderSup':dat.concepto!==''}">{{dat.concepto}}</td>
                      <td class="w3-elemento-tableIndicador borderIzq alinCenter anchoValores" [ngClass]="{'borderInf borderSup':dat.factor!==''}">
                        {{dat.factor}}
                        @if (dat.codigo!=='t' && dat.codigo !=='e' && dat.codigo !=='p') {
                          %
                        }
                      </td>
                      <td class="w3-elemento-tableIndicador borderIzq alinRight anchoValores" [ngClass]="{'borderInf borderSup':dat.saldo!==''}">
                        @if (dat.codigo!=='r' && dat.codigo!=='e') {
                          <span style="margin-right: 5%;">{{formNum(dat.saldo, false)}}</span>
                        }
                        @if (dat.codigo === 'e') {
                          <span style="margin-right: 5%;">{{formNum(dat.saldo, true)}}</span>
                        }
                        @if (dat.codigo==='r') {
                          <span style="margin-right: 5%;">{{dat.saldo}}</span>
                        }
                        @if (dat.codigo==='e'||dat.codigo==='p') {
                          <span style="margin-right: 5%; margin-left: -5%;"> %</span>
                        }
                      </td>
                      @if (dat.rowspan!==0) {
                        <td [attr.rowspan]="dat.rowspan" class="w3-elemento-tableIndicador  borderIzq anchoValores alinRight"
                        [ngClass]="{'borderInf borderSup':dat.codigo!=='' && dat.codigo!=='t'}">
                          @if (dat.codigo !=='t' && dat.codigo !=='e') {
                            <span>{{formNum(dat.admisible, false)}}</span>
                          }
                          @if (dat.codigo ==='t') {
                            <span>{{dat.admisible}}</span>
                          }
                          @if (dat.codigo==='p') {
                            <span style="margin-right: 5%;"> %</span>
                          }
                          @if (dat.codigo ==='e') {
                            <span (dblclick)="cambioPorcen()" style="cursor: pointer;">
                              {{porcent}} %
                              <mat-icon class="iconoMen">edit</mat-icon>
                            </span>
                          }
                        </td>
                      }
                    </tr>
                  }
                }
              }
            </tbody>
          </table>        
      </div>
    </div>

    <div class="zona2 ">
      <div class="containerTarjets">
        <div class="headersTransparent w3-titulo-contenidomenuSC">
          <span class="w3-margin-left-contenido"> {{ 'liquidez.cobertura.tituloTabla5' | translate }} </span>
        </div>
        <div class="w3-row contenedorCompleto">
          <div class="w3-row w3-white w3-margin-top" style="height: 15vh;">
            <app-tarjetas
            [header]="'liquidez.cobertura.tituloTabla6' | translate"
            [valueStr]="icl"
            [footer]="escrituraPer(subTitles)"
            [icon]="''"
            ></app-tarjetas>
          </div>
        </div>
      </div>
      <div class="containerGraf" id="conteGrafica">
        <div class="headersTransparent w3-titulo-contenidomenuSC">
          <div class="w3-setenta2 textoOverFlow">
            <span class="w3-margin-left-contenido"> {{ 'liquidez.cobertura.tituloTabla7' | translate }} </span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo" [customTooltip]="tooltipTemplate">
              @for (per of subTitles2; track per; let p = $index) {
                @if (p === 0 || p === subTitles2.length-1 ) {
                  {{escrituraPer(per)}}
                  @if (p === 0){
                    -
                  }
                }
              }
            </span>
            <ng-template #tooltipTemplate>
              @for (per of subTitles2; track per; let p = $index) {
                <span class="subtituloTooltip"> {{escrituraPer(per)}} </span>
                @if (p !==subTitles2.length-1) {
                  <span class="subtituloTooltip" style="margin-left: 5px; margin-right: 5px;">|</span>
                }
              }
            </ng-template>
          </div>
          <div class="w3-rest w3-right">
            <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}" (click)="etiquetas = !etiquetas">
              {{!etiquetas ? 'label' : 'label_off'}}
            </mat-icon>
            <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}"
            (click)="openModal('graf1')" matTooltip="{{'financiero.indicadoresProductividad.tooltipIcono2'|translate}}">
              zoom_out_map
            </mat-icon>
            <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
            [matMenuTriggerFor]="menuGrafPrincipal">
              more_vert
            </mat-icon>
            <mat-menu #menuGrafPrincipal="matMenu">
              <button class="mat-menu-item w3-caja-menu" mat-menu-item [matMenuTriggerFor]="menuGraf">
                <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{'financiero.indicadoresProductividad.tooltipIcono3'|translate}}</span>
              </button>
            <button class="mat-menu-item w3-caja-menu" mat-menu-item (click)="exportarGrafica('conteGrafica', 'liquidez.cobertura.tituloTabla7')">
                  <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                  <span>{{'menu.Exportar' | translate}}</span>
                </button></mat-menu>
            <mat-menu #menuGraf="matMenu">
              <button  class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'line'}" [disabled]="tipoGraf === 'line'" (click)="changeGrafic('line')">
                <mat-icon [ngStyle]="{'color':'gray'}">show_chart</mat-icon>
                <span>{{'financiero.indicadoresProductividad.tooltipIcono5'|translate}}</span>
              </button>
              <button  class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'area'}" [disabled]="tipoGraf === 'area'" (click)="changeGrafic('area')">
                <mat-icon [ngStyle]="{'color':'gray'}">area_chart</mat-icon>
                <span>{{'financiero.indicadoresProductividad.tooltipIcono8'|translate}}</span>
              </button>
              <button  class="mat-menu-item w3-caja-menu" mat-menu-item [ngClass]="{'w3-disabled': tipoGraf === 'bar'}" [disabled]="tipoGraf === 'bar'" (click)="changeGrafic('bar')">
                <mat-icon [ngStyle]="{'color':'gray'}">bar_chart</mat-icon>
                <span>{{'financiero.indicadoresProductividad.tooltipIcono4'|translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        @if (verGraf) {
          <div class="graff">
            <div style="margin-left: auto; margin-right: auto; height: 100%; width: 98%;">
              <app-graficador
                [data]="[datos]"
                [labels]="evaluaciones"
                [etiquetas]="etiquetas"
                [type]="typeGraph"
                [axisX]="''"
                [axisY]="['']"
                [zona]="1"
                [formatEtiquetas]="true"
                [colors]="colorMono"
                [animations]="true"
                [speedAnimations]="500"
                [legend]="{enabled: true, position: 'bottom'}"
              ></app-graficador>
            </div>
          </div>
        }@else {
          <div class="graff">
            <app-skeleton-grafica [leyendas]="3" [barras]="9"/>
          </div>
        }
      </div>
    </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal">
  <div header-modal>
    <span class="w3-margin-left-contenido"> {{ 'liquidez.cobertura.tituloTabla5' | translate }} </span>
    <span class="w3-margin-left-contenido">&bull;</span>
    <span class="w3-margin-left-filter w3-subtitulo">
      @for (per of subTitles2; track per; let i = $index) {
        @if (i === 0 || i === subTitles2.length-1) {
          {{escrituraPer(per)}}
          @if (i===0) {
            -
          }
        }
      }
    </span>
  </div>
</app-modal>

<div id="ampliar" class="modal" (click)="clickFuera($event)">
  <div class="modalContent" style="width: 80%;">
    <div class="w3-row">
      <div class="w3-noventa2">
        <div class="w3-row w3-header-cuadrante padreizquierda" style="height: 6vh; margin-top: 10px; margin-left: 20px;">
          <div class="w3-noventa2 w3-titulo-contenidomenu bottom hijoizquierdaTitle" >
            <div class="hijoizquierdaTitle">
                <div class="w3-row">
                  <div class="w3-noventa w3-titulo-contenidomenu padreizquierda">
                    <div class="hijoizquierdaTitle">
                      <span class="w3-margin-left-contenido"> {{ 'liquidez.cobertura.tituloTabla5' | translate }} </span>
                      <span class="w3-margin-left-contenido">&bull;</span>
                      <span class="w3-margin-left-filter w3-subtitulo">
                        @for (per of subTitles2; track per; let i = $index) {
                          @if (i === 0 || i === subTitles2.length-1) {
                            {{escrituraPer(per)}}
                            @if (i===0) {
                              -
                            }
                          }
                        }
                      </span>
                    </div>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="w3-rest w3-right" style="height: 6vh; margin-top: 10px;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <mat-icon class="w3-button w3-dropdown-click iconoMen" [ngStyle]="{'color':'gray'}" (click)="etiquetas = !etiquetas">
            {{!etiquetas ? 'label' : 'label_off'}}
          </mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}" (click)="exportarGrafica('conteGrafica', 'liquidez.cobertura.tituloTabla7')">
            image
          </mat-icon>
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click" (click)="closeModal()">clear</mat-icon>
        </div>
      </div>
    </div>
    <div class="w3-row" style="padding-left: 2%; padding-bottom: 1%; padding-right: 2%; background-color: transparent; border-radius: 1.5vh;">
        @if (modal) {
          <div class="w3-row contentGraf">
            <app-graficador
              [data]="[datos]"
              [labels]="evaluaciones"
              [etiquetas]="etiquetas"
              [type]="typeGraph"
              [axisX]="''"
              [axisY]="['']"
              [zona]="2"
              [formatEtiquetas]="true"
              [colors]="colorMono"
              [animations]="true"
              [speedAnimations]="500"
              [legend]="{enabled: true, position: 'bottom'}"
            ></app-graficador>
          </div>
        }
    </div>
  </div>
</div>